import { useBookDelete } from '@/module/Author/Book';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface BookDeleteButtonProps {
  bookId: Id;
}

export function BookDeleteButton({ bookId }: BookDeleteButtonProps) {
  const mutation = useBookDelete(bookId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
